'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import { useBenefitMenus } from '../_hooks/useBenefitMenus';
import { useOpenOfferwall } from '../_hooks/useOpenOfferwall';
import { findMissionGroupIndex } from '../_utils/resolveBenefitMenuGroups';
import { BenefitMenuRow } from './BenefitMenuRow';
export const BENEFIT_SECTION_CLASS_NAME = 'flex flex-col gap-12 bg-Gray-white p-20 xl:rounded-medium xl:border xl:border-Gray-100';

//* 퀵액션의 오퍼월 타일이 스크롤로 데려오는 지점.
export const BENEFIT_MISSION_SECTION_ID = 'benefit-mission-section';
interface BenefitMenuSectionProps {
  /** 첫 그룹을 BenefitQuickActionSection이 타일로 전시하는 페이지에서만 켠다(혜택홈). */
  skipQuickActionGroup?: boolean;
}
export const BenefitMenuSection = t0 => {
  const $ = _c(15);
  const {
    skipQuickActionGroup
  } = t0;
  const {
    data: groups
  } = useBenefitMenus();
  const {
    openOfferwall,
    gateModals
  } = useOpenOfferwall();
  let t1;
  if ($[0] !== groups || $[1] !== skipQuickActionGroup) {
    t1 = skipQuickActionGroup ? groups.slice(1) : groups;
    $[0] = groups;
    $[1] = skipQuickActionGroup;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const listGroups = t1;
  let t2;
  if ($[3] !== listGroups) {
    t2 = findMissionGroupIndex(listGroups);
    $[3] = listGroups;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const missionGroupIndex = t2;
  if (listGroups.length === 0) {
    return null;
  }
  let t3;
  if ($[5] !== listGroups || $[6] !== missionGroupIndex || $[7] !== openOfferwall) {
    let t4;
    if ($[9] !== missionGroupIndex || $[10] !== openOfferwall) {
      t4 = (group, index) => <section key={group.title} id={index === missionGroupIndex ? BENEFIT_MISSION_SECTION_ID : undefined} className={cn(BENEFIT_SECTION_CLASS_NAME, index === missionGroupIndex && "scroll-mt-48 xl:scroll-mt-72")}><h2 className="font-700 text-Gray-900 typo-body3">{group.title}</h2><ul className="flex flex-col">{group.items.map(item => {
            const {
              placementKey
            } = item;
            return <li key={item.title}><BenefitMenuRow imageUrl={item.imageUrl} title={item.title} description={item.description} isNew={item.isNew} href={item.url} onSelect={!item.url && placementKey ? () => openOfferwall(placementKey) : undefined} /></li>;
          })}</ul></section>;
      $[9] = missionGroupIndex;
      $[10] = openOfferwall;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = listGroups.map(t4);
    $[5] = listGroups;
    $[6] = missionGroupIndex;
    $[7] = openOfferwall;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== gateModals || $[13] !== t3) {
    t4 = <>{t3}{gateModals}</>;
    $[12] = gateModals;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};

//* 서버 프리페치가 실패했을 때만 노출되는 폴백 — 한 섹션 분량의 레이아웃 공간만 예약한다.
export const BenefitMenuSectionFallback = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton typo="body3" className="w-96 rounded-xsmall" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className={BENEFIT_SECTION_CLASS_NAME}>{t0}<ul className="flex flex-col">{[0, 1, 2].map(_temp)}</ul></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(row) {
  return <li key={row} className="flex items-center gap-16 py-12"><Skeleton className="size-40 rounded-small" /><div className="flex flex-col items-start"><Skeleton typo="body4" className="w-120 rounded-xsmall" /><Skeleton typo="caption1" className="w-160 rounded-xsmall" /></div></li>;
}